/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	import EasingFunction = alm.math.EasingFunction;
	import Cmd = alm.util.Cmd;
	import Easing = alm.math.Easing;

	export class FreeBehavior implements ICameraBehavior {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(camera:THREE.PerspectiveCamera) {
			this.camera = camera;

			this.camera.position.set(0, 100, 1000);
			this.camera.lookAt(new THREE.Vector3(0, 0, 0));

			/*
			this.clock = new THREE.Clock();

			this.controls = new THREE.FirstPersonControls(this.camera);

			this.controls.lookSpeed = 0.4;
			this.controls.movementSpeed = 20;
			this.controls.noFly = true;
			this.controls.lookVertical = true;
			this.controls.autoForward = false;
			this.controls.activeLook = false;

			// 首を上下する角度
			this.controls.constrainVertical = true;
			this.controls.verticalMin = 1.0;
			this.controls.verticalMax = 2.0;

			// カメラの初期方向
			this.controls.lon = -150;
			this.controls.lat = 120;
			*/

			this.motionStartAttitude = new FreeCameraAttitude();
			this.motionEndAttitude = new FreeCameraAttitude();
			this.isAnimating = false;

			this.animatedPosition = new THREE.Vector3();
			this.animatedRotation = new THREE.Euler();

			this.stop();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public start():void {
			trace('[FreeBehavior] start');
			//this.controls.enabled = true;
		}

		public stop():void {
			trace('[FreeBehavior] stop');
			//this.controls.enabled = false;
			//this.controls.dispose();

			this.stopAnimation();
		}





		public reset(center:THREE.Vector3):void {
			this.stopAnimation();
		}

		public update(center:THREE.Vector3, useTransition:boolean = true):void {
			if (this.isAnimating) {
				this.camera.position.copy(this.animatedPosition);
				this.camera.setRotationFromEuler(this.animatedRotation);

			} else {
				//const delta = this.clock.getDelta();
				//this.controls.update(delta);
			}
		}

		public resize(stageWidth:number, stageHeight:number):void {
		}





		public recordAttitudeAsStart():void {
			this.recordAttitude(this.motionStartAttitude);
		}

		public recordAttitudeAsEnd():void {
			this.recordAttitude(this.motionEndAttitude);
		}

		private recordAttitude(attitude:FreeCameraAttitude):void {
			const position = this.camera.position;
			const rotation = this.camera.rotation;
			trace('[FreeBehavior] record attitude, position =', [position.x,  position.y, position.z], ', rotation =', [rotation.x, rotation.y, rotation.z]);
			attitude.set(position, rotation);
		}

		public playAnimation(duration:number, easing:EasingFunction):void {
			this.stopAnimation();

			const startPosition:THREE.Vector3 = this.motionStartAttitude.getPosition();
			const startRotation:THREE.Euler = this.motionStartAttitude.getRotation();

			const endPosition:THREE.Vector3 = this.motionEndAttitude.getPosition();
			const endRotation:THREE.Euler = this.motionEndAttitude.getRotation();

			this.motionTween = new cmd.Serial(
				new cmd.Func(():void => {
					trace('[FreeBehavior] animation start');
					this.isAnimating = true;
					//this.controls.enabled = false;
				}),
				new cmd.Parallel(
					new cmd.Tween(this.animatedPosition, { x: endPosition.x, y: endPosition.y, z: endPosition.z }, { x: startPosition.x, y: startPosition.y, z: startPosition.z }, duration, easing),
					new cmd.Tween(this.animatedRotation, { x: endRotation.x, y: endRotation.y, z: endRotation.z }, { x: startRotation.x, y: startRotation.y, z: startRotation.z }, duration, easing)
				),
				new cmd.Func(():void => {
					trace('[FreeBehavior] animation end');
					this.isAnimating = false;
					//this.controls.enabled = true;
				})
			);
			this.motionTween.execute();
		}

		public stopAnimation():void {
			if (!this.isAnimating) return;
			this.isAnimating = false;

			this.motionTween = Cmd.stop(this.motionTween);
		}

		public animateCamera(from:object, to:object, duration:number):void {
			this.motionStartAttitude.set(new THREE.Vector3(from['positionX'], from['positionY'], from['positionZ']), new THREE.Euler(from['rotationX'], from['rotationY'], from['rotationZ']));
			this.motionEndAttitude.set(new THREE.Vector3(to['positionX'], to['positionY'], to['positionZ']), new THREE.Euler(to['rotationX'], to['rotationY'], to['rotationZ']));
			this.playAnimation(duration, Easing.easeInOutQuad);
		}

		public getAttitudeString():string {
			const position = this.camera.position;
			const rotation = this.camera.rotation;
			return JSON.stringify({ positionX: position.x, positionY: position.y, positionZ: position.z, rotationX: rotation.x, rotationY: rotation.y, rotationZ: rotation.z });
		}





		public onKeyDown(keyCode:number, shiftKey:boolean):void {
		};

		public onKeyUp(keyCode:number, shiftKey:boolean):void {
		}

		public onMouseDown(mouseX:number, mouseY:number, button:number):void {
			this.isMouseDown = true;

			this.mouseDownX = mouseX;
			this.mouseDownY = mouseY;
		};

		public onMouseUp(mouseX:number, mouseY:number, button:number):void {
			this.isMouseDown = false;
		};

		public onMouseMove(mouseX:number, mouseY:number, button:number):void {
			if (!this.isMouseDown) return;

			const scale = 0.1;

			this.mouseDragX = mouseX - this.mouseDownX;
			this.mouseDragY = mouseY - this.mouseDownY;

			if (button == 0) {
				this.camera.position.y -= this.mouseDragX * scale;
				this.camera.position.x -= this.mouseDragY * scale;
			} else if (button == 2) {
				this.camera.quaternion.y -= this.mouseDragX * scale;
				this.camera.quaternion.x -= this.mouseDragY * scale;
			}
		};

		public onMouseWheel(delta:number):void {
			const scale = 0.1;

			this.camera.position.z += delta * scale;
		};





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private camera:THREE.PerspectiveCamera;

		//private clock:THREE.Clock;
		//private controls:THREE.FirstPersonControls;

		private isMouseDown:boolean;
		private mouseDownX:number;
		private mouseDownY:number;
		private mouseDragX:number;
		private mouseDragY:number;

		private motionStartAttitude:FreeCameraAttitude;
		private motionEndAttitude:FreeCameraAttitude;
		private isAnimating:boolean;
		private motionTween:cmd.Serial;

		private animatedPosition:THREE.Vector3;
		private animatedRotation:THREE.Euler;
	}
}
